<template>
    <section class="quiz__campaign-question quiz__campaign-question-active">
        <div class="quiz__campaign-question-block" :class="{ 'quiz__campaign-question-block-has-image' : question.desktop_media_id }">
            <div class="quiz__campaign-question-mobile-fallback"  :style="backgroundImage"></div>
            <img class="quiz__campaign-question-image" v-if="question.desktop_media_id" :src="question.desktop_media" />
            <p class="quiz__campaign-question-text">
                <small class="quiz__campaign-question-number">{{ currentQuestionNumber }}<br></small>
                <span v-html="question.content"></span>
            </p>
        </div>
        <div class="quiz__campaign-answers" :class="{ 'quiz__campaign-answers-balanced' : (answersAmount == 2) }">
            <answer :answertype="question.presentation_style_id" :question="question" :answer="answer" v-for="(answer, key) in question.answers" :answer_given="answer_given" :key="'answer_'+key"></answer>
        </div>
    </section>
</template>
<script>
import Answer from './answer';
export default {
    props: ['question','index','questionsinpage', 'question_number'],
    components: {
        Answer
    },
    computed: {
        backgroundImage: function(){
            return (this.question.mobile_media_id!==null) ? 'background-image:url('+ this.question.mobile_media +');' : '' ;
        },
        answersAmount: function(){
            return this.question.answers.length;
        },
        currentQuestionNumber: function() {
            return String(this.questionNumber).padStart(2,0);
        },
        registerInRoute: function()
        {
            return ((this.questionsinpage == 1 && (this.question.quiz_campaign_question_type_id == 4 || this.question.quiz_campaign_question_type_id == 1 || this.question.quiz_campaign_question_type_id == 2)) || this.question.is_last_question === true || this.lastOnPage === true);
        },
        lastOnPage: function()
        {
            return ((this.index + 1) == this.questionsinpage);
        }
    },
    methods : {
        updateQuestionVisibility( question = null )
        {
            Event.$emit('question_moving', { next_question : question.id });
        }
    },
    created() {
        let vm = this;
        Event.$on('start_quiz', ($event) => { vm.active_question = (vm.index==0) ? true : false; });
        Event.$on('question_'+ vm.question.id +'_answered', ($event) => {
            vm.answer_given = true;
            if( vm.question.include_in_endpoint == 1 )
            {
                Event.$emit('build_answers_given', { question_id: $event.question_id, answer_content: $event.answer_content });
            } else {
                Event.$emit('did_not_work');
            }
        });
    },
    mounted (){
        if( this.registerInRoute === true )
        {
            Event.$emit('build_endpoint_key', { question_id: this.question.id });
        }
    },
    data() {
        return {
            answer_given: false,
            active_question: false,
            next_question: null,
            questionNumber: this.question_number
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/paged-question.vue